import styled from 'styled-components';

const ChartsWrapper = styled.div`
	width: 100%;
	height: 100%;
`;

export default ChartsWrapper;
